var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cbp_tmicon",class:_vm.stateobj.classe ? _vm.stateobj.classe : 'bg-secondary'},[_c('span',{staticClass:"text-white"},[_c('i',{staticClass:"fa",class:_vm.stateobj.icon ? _vm.stateobj.icon : 'Non disponible',attrs:{"aria-hidden":"true"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }